//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { HEADER, MOBILE, TABLET } from '@/scripts/constants/media-query'
import { ACTION_RESET_MENU_ID, ACTION_UPDATE_MENU_ID } from '@/scripts/store/header/actions'
import { createNamespacedHelpers } from 'vuex'

const { mapGetters: mapGettersHeader, mapActions: mapActionsHeader } =
  createNamespacedHelpers('header')

const JAVASCRIPT_TRIGGER_VUE_METHOD = 'javascript:triggerVueMethod'

export default {
  name: 'rb-header-main-menu-item',
  props: {
    menuId: {
      type: String,
      default: '',
    },
    analyticsElementId: {
      type: String,
      default: '',
    },
    analyticsDescription: {
      type: String,
      default: '',
    },
    isHighlighted: {
      type: Boolean,
      default: false,
    },
    href: { type: String },
  },
  data() {
    return {
      debounceFlag: true,
      uniqueId: null,
    }
  },
  computed: {
    ...mapGettersHeader(['currentMenuId', 'keyboardNavigation']),
    isMobile() {
      return this.$mq === MOBILE || this.$mq === TABLET || this.$mq === HEADER
    },
    canShowItemBar() {
      if (this.isMobile) return false
      return this.menuId === this.currentMenuId
    },
    tabIndex() {
      if (!this.currentMenuId) {
        return '0'
      }

      if (this.keyboardNavigation.focusedElementIsLastInsideSubmenu) {
        return '0'
      }

      if (
        this.keyboardNavigation.focusedElementIsInsideMainMenu ||
        this.keyboardNavigation.focusedElementIsInsideSubmenu
      ) {
        if (
          this.keyboardNavigation.menuIds.indexOf(this.keyboardNavigation.currentId) >
          this.keyboardNavigation.menuIds.indexOf(this.uniqueId)
        ) {
          return '0'
        }
        return -1
      }

      return '0'
    },
  },
  mounted() {
    this.uniqueId = this._uid
    if (this.$refs.mainMenuElement) {
      this.setWElement()
    }
  },
  methods: {
    ...mapActionsHeader({
      updateMenuId: ACTION_UPDATE_MENU_ID,
      resetMenuId: ACTION_RESET_MENU_ID,
    }),
    // TODO: Rename function
    onButtonClick(menuId) {
      if (menuId && this.debounceFlag) {
        this.clickDebounce()
        if (menuId === this.currentMenuId) {
          this.resetMenuId()
        } else {
          this.resetMenuId()

          this.$nextTick(() => {
            this.updateMenuId(menuId)
          })
        }
      } else if (this.href.includes(JAVASCRIPT_TRIGGER_VUE_METHOD)) {
        this.cleanAndTriggerActionFromCMS()
      } else {
        // TODO: Check if it is needed handling a href on main-menu-item
        window.location.href = this.href
      }
    },
    // TODO: Find a better implementation on both CMS / WCS / FE side for handling triggerVueMethod from CMS
    cleanAndTriggerActionFromCMS() {
      const splitHref = this.href.split(JAVASCRIPT_TRIGGER_VUE_METHOD)
      if (splitHref && splitHref[1]) {
        const dirtyMethodToTrigger = splitHref[1]
        const methodToTrigger = dirtyMethodToTrigger.replace("('", '').replace("')", '')
        methodToTrigger && window.triggerVueMethod(methodToTrigger)
      }
    },
    clickDebounce() {
      this.debounceFlag = false
      setTimeout(() => {
        this.debounceFlag = true
      }, 500)
    },
    setWElement() {
      const buttonBarElement = this.$refs.mainMenuElement.querySelector('.button__bar')
      const badgeElement = this.$refs.mainMenuElement.querySelector('.rb-pill')
      if (badgeElement && buttonBarElement) {
        const { offsetLeft } = badgeElement
        buttonBarElement.style.width = `${offsetLeft - 8}px`
      }
    },
  },
}
